import DashboardSpecializationsCardList from "./DashboardSpecializationsCardList";

export default DashboardSpecializationsCardList;
